import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
const { Card, CardOverflow, AspectRatio,  CardContent, Typography, } = require("@mui/joy");

function PersonCard({ person, size }) {


    return (
        <Card variant="outlined" sx={{ width: size }}>
            <CardOverflow>
                <AspectRatio ratio="1.2">
                    <img
                        src={person.image}
                        loading="lazy"
                        alt=""
                    />
                </AspectRatio>


            </CardOverflow>
            <CardContent>
                <Typography level="title-md">
                    {person.title}

                </Typography>
                <Typography level="body-sm">
                    {person.name}

                </Typography>

                {person.fb !== "" &&
                    <FontAwesomeIcon 
                    style={{ cursor: "pointer" }}
                    onClick={() => {

                        window.open(person.fb, "_blank");
                    }} icon={faInstagram} />}

            </CardContent>

        </Card>)
}

export default PersonCard